<template>
  <div class="body">
      <p  class="font1" style="padding-top: 8vh;">书籍是通向智慧的钥匙，让我们在知识的海洋中遨游，发现更好的自己！</p>

      <div class="wrapper">
          <div class="bookTextOne">
              <h3>倾听的力量</h3>
              <div id="qiymet2" @click="openPDF(1)">
                  <p>
                      <i class="fa fa-eye fa-2x"></i>
                  </p>
              </div>
              <p style="padding-bottom: 4px;width: 100%;">作者:[美] 马克·郭士顿</p>
             
          </div>
          <div class="bookTextTwo">
              <h3>用数字讲故事</h3>
              <div id="qiymet1" @click="openPDF(2)">
                  <p>
                      <i class="fa fa-eye fa-2x"></i>
                  </p>
              </div>
              <p style="padding-bottom: 4px;width: 100%;">作者：[美]奇普·希思，[美]卡拉·斯塔尔</p>  
          </div>
      </div>
  </div>
</template>

<script>
export default {
props: {
  ReportData: {
  type: Object,
  default: {}
  }
},
data() {
  return {
          widthWindow: window.innerWidth, 
          widthBlock: window.innerWidth*0.47,
          heightBlock: window.innerHeight*0.257,
          bookPage: 1,
          bookId: 0,
          // bookShow: false,
  }
},
methods: {
  openPDF(bookPage) {
    if(bookPage === 1){
      // this.bookPage = 1
      // this.bookId = 1
              window.location.href = 'https://iedu.foxconn.com/public/play/playCourse?courseId=54209';
    } else {
      // this.bookPage = 2
      // this.bookId = 2
              window.location.href = 'https://iedu.foxconn.com/public/play/playCourse?courseId=54208';
    }
    // this.bookShow = true
  },
}
}
</script>

<style scoped>
.body {
    background: 
    url("../../assets/25March/logo.png") right  top  no-repeat,
    url("../../assets/25March/bg.jpg")  no-repeat;
    background-size:100% 100%,cover;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;  
    align-items: center;  
}
.font1 {
    width: 96%;
    margin: 0;
    /* text-align: center; */
    font-size: 20px;
    color: #64892f;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    margin: 0 auto;
    padding: 0;
    color: #000;
    font-size: 20px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #36854f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 2000;
    /* bottom: 20%; */
    width: 91%;
    height: auto;
    background: #fff;
    border-radius: 7px;
    padding: 7px;
    box-shadow: #eae62ebd 1px;
}

.fa {
    color: #fff8e8;
}


.wrapper {
    z-index: 1000;
    width: 97%;
    /* height: auto; */
    height: 40vh;
    display: flex;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 10px;;
    border-radius: 17px;
    margin: 0 auto;
    flex-wrap: wrap;
}

.bookOne {
    width: 30%;
    height: 20%;
    /* margin-top: 10px; */
}

.bookTwo {
    width: 30%;
    height: 20%;
}

.bookTextOne {
    margin-left: 11px;
    width: 90%;
    height: 90px;
    color: #000;
}
.bookTextTwo {
    margin-left: 11px;
    width: 90%;
    height: 130px;
    color: #000;
  }

  #qiymet2 {
    float: right;
    margin-right: 20px;
    margin-top: -35px;
    padding: 0px 17px 0px 17px;
    border-radius: 20px;
    color: #000;
    font-family: 'Source Code Pro', cursive;
    background-color: rgb(39, 178, 217);
}

#qiymet1 {
    float: right;
    margin-right: 20px;
    margin-top: -35px;
    padding: 0px 17px 0px 17px;
    /* width: 51px;
    height: 51px; */
    border-radius: 20px;
    color: #000;
    font-family: 'Source Code Pro', cursive;
    background-color: rgb(39, 178, 217);
    z-index: 1000;
}

.zezhao {
    width: 100%;
    height: 100%;
    background: #000000bc;
    z-index: 1920;
    position: absolute;
}

button {
    border: none;
    outline: none;
    background-color: rgb(39, 178, 217);
    padding: 10px 20px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    border-radius: 5px;
    transition: all ease 0.1s;
    box-shadow: 0px 5px 0px 0px rgb(116, 219, 247);
    margin: 5px;
}

button:active {
    transform: translateY(5px);
    box-shadow: 0px 0px 0px 0px rgb(116, 219, 247);
}

.donghua{
    animation:flash 3s infinite
  }
  @keyframes flash {
    0% {
      opacity: 0;
    }
    80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
}
</style>